var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HMModalContainer',[_c('template',{slot:"header"},[_c('HMHeader')],1),_c('HMModalHeader',{attrs:{"title":_vm.$t('UNSUBSCRIBE.TITLE.EMAIL_UNSUBSCRIBE'),"closable":false}}),_c('h1',{staticClass:"title mb-3",domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.$t('UNSUBSCRIBE.TITLE.HELLO_USER', _vm.userData)))}}),(_vm.user.emails_enabled)?_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.sanitize(
          _vm.$t(
            'UNSUBSCRIBE.TEXT.YOU_HAVE_SUCCESSFULLY_SUBSCRIBED_TO_EMAILS',
            _vm.userData
          )
        )
      )}}),(_vm.user.emails_enabled)?_c('HMButton',{staticClass:"w-100 mt-2",attrs:{"color":"primary"},on:{"click":function($event){return _vm.updateUserByUUID(false)}}},[_vm._v(" "+_vm._s(_vm.$t('UNSUBSCRIBE.BUTTON.UNSUBSCRIBE'))+" ")]):_vm._e()],1):_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.sanitize(
          _vm.$t(
            'UNSUBSCRIBE.TEXT.YOU_HAVE_SUCCESSFULLY_UNSUBSCRIBED_FROM_EMAILS',
            _vm.userData
          )
        )
      )}}),_c('HMButton',{staticClass:"w-100 mt-2",attrs:{"color":"primary"},on:{"click":function($event){return _vm.updateUserByUUID(true)}}},[_vm._v(" "+_vm._s(_vm.$t('UNSUBSCRIBE.BUTTON.SUBSCRIBE'))+" ")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }